<template>
  <div class="product-list-empty-block">
    <div class="product-list-empty-block__text">
      <i18n-t keypath="components.catalog.productListEmptyBlock.empty.text">
        <template #br>
          <br>
        </template>
      </i18n-t>
    </div>
    <ButtonBlackBig
      class="mt-10"
      @click="clearAllFilters"
    >
      {{ $t('components.catalog.productListEmptyBlock.clearAllFilters') }}
    </ButtonBlackBig>
  </div>
</template>

<script lang="ts" setup>
import ButtonBlackBig from '~/components/ui/ButtonBlackBig.vue';
import { useCommonFilters } from '~/services/catalogFilter/common';

const route = useRoute();
const router = useRouter();

const { clearAllFilters } = useCommonFilters(route, router);
</script>

<style scoped lang="scss">
@tailwind components;

@layer components {
  .product-list-empty-block {
    @apply flex items-center flex-col pt-14;

    &__text {
      @apply text-center text-2xl text-[#333] font-bold;
    }
  }
}
</style>
